import { MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";
import API from "../../../services/API";
import UserContext from "../../../services/Context/UserContext";
import useProduct from "../utils/useProduct";
import { getLang } from "../../../services/translation";
import origins from "../../../config/origins.json";

export default function OriginSelect() {

    const { user } = useContext(UserContext);

    const product = useProduct();

    const [value, setValue] = useState('');

    const handleChange = e => {
        const origin = origins.find(o => o.id === e.target.value);
        setValue(origin?.id || '');
        if (!origin) return null;
        API.post('/enroll/attempts', { user, product: product || { id: 'standard' }, origin });
    }

    if (getLang() !== 'fr') return <></>;

    if (!user) return <></>;
    
    return (
        <Stack spacing={3}>

            <Typography variant="h5" align="center">
                Où avez-vous découvert cette formation ?
            </Typography>

            <TextField
                label="Choisir une option"
                value={value}
                onChange={handleChange}
                select
                required
            >
                {origins
                    .sort((a,b) => a.title > b.title ? 1 : -1)
                    .map(o => 
                        <MenuItem value={o.id} key={o.id}>
                            {o.title}
                        </MenuItem>
                    )}
            </TextField>

        </Stack>
    );
}